import { createSlice } from '@reduxjs/toolkit'

import { TAB_FABRICATION, TAB_STENCILS, TAB_PCB_PARTS, TAB_ACCESORIES, TAB_ASSEMBLY  } from './data/tabType';

const isValidTab = (tab) => {
  return tab === TAB_FABRICATION || tab === TAB_STENCILS || tab === TAB_PCB_PARTS || tab === TAB_ACCESORIES || tab === TAB_ASSEMBLY;
}

let initialTab;
if(isValidTab(Spree.active_tab)){
  initialTab = Spree.active_tab;
}else if (Spree.fabrication) {
  initialTab = TAB_FABRICATION;
} else if (Spree.stencils) {
  initialTab = TAB_STENCILS;
} else if(Spree.assembly) {
  initialTab = TAB_ASSEMBLY;
} else if(Spree.parts) {
  initialTab = TAB_PCB_PARTS;
} else if (Spree.accessories) {
  initialTab = TAB_ACCESORIES;
} else {
  initialTab = TAB_FABRICATION;
}

const tabService = createSlice({
  name: 'tabService',
  initialState: {
    activeTab: initialTab,
  },
  reducers: {
    changeTab(state, action) {
      state.activeTab = action.payload;
    },
  },
});

export const {
  changeTab,
} = tabService.actions

export default tabService.reducer;
